import { Card, Skeleton } from "antd";
import React from "react";

/** Skeleton matching dashboard StatCard layout. */
export const StatCardSkeleton: React.FC = () => (
  <Card size="small" styles={{ body: { minHeight: 140 } }}>
    <Skeleton.Input active size="small" style={{ width: "40%", marginBottom: 12 }} />
    <Skeleton.Input active size="default" style={{ width: "55%", marginBottom: 16 }} />
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <Skeleton.Button active size="small" style={{ width: 88 }} />
    </div>
  </Card>
);
